import type { RemoveFromCartData } from '@/events/conversion';

import { BaseTracker } from './BaseTracker';
import type { TrackerFactory } from './TrackerFactory';

export class RemoveFromCartTracker extends BaseTracker {
  constructor(factory: TrackerFactory) {
    super(factory);
  }

  track(data?: RemoveFromCartData): void {
    if (!this.factory.isManualEnabled('removeFromCart')) return;
    this.factory.dispatchManual('REMOVE_FROM_CART', data);
  }
}
